export const FETCH_FOOTER_DETAILS_BEGIN = 'FETCH_FOOTER_DETAILS_BEGIN';
export const FETCH_FOOTER_DETAILS_SUCCESS = 'FETCH_FOOTER_DETAILS_SUCCESS';
export const FETCH_FOOTER_DETAILS_FAILURE = 'FETCH_FOOTER_DETAILS_FAILURE';
export const RESET_FOOTER_DETAILS = 'RESET_FOOTER_DETAILS';